"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Fonts = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const TravelNest_woff_1 = __importDefault(require("./fonts/TravelNest.woff"));
exports.Fonts = styled_1.default.style `
@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500&display=swap&subset=latin-ext');

@font-face {
	font-family: 'TravelNest';
	font-style: normal;
	font-weight: normal;
	src: local('TravelNest'), url('${TravelNest_woff_1.default}') format('woff');
}
`;
//# sourceMappingURL=fonts.js.map